import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContadorService } from 'src/app/services/contador.service';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/token.service';

@Component({
  selector: 'app-modal-editar-contador',
  templateUrl: './modal-editar-contador.component.html',
  styleUrls: ['./modal-editar-contador.component.scss']
})
export class ModalEditarContadorComponent implements OnInit {

  @Input() contador: any;
  @Output() reload = new EventEmitter<any>();

  public telefone: any;
  public isLoading: boolean = false;
  public tipoDoc: string;
  public seqCRCFull: string;
  public seqCRC: string;

  
  public estados = [
    {"codigo": 1,"nome": "Acre","sigla": "AC"},
    {"codigo": 2,"nome": "Alagoas","sigla": "AL"},
    {"codigo": 4,"nome": "Amazonas","sigla": "AM"},
    {"codigo": 3,"nome": "Amapá","sigla": "AP"},
    {"codigo": 5,"nome": "Bahia","sigla": "BA"},
    {"codigo": 6,"nome": "Ceará","sigla": "CE"},
    {"codigo": 7,"nome": "Distrito Federal","sigla": "DF"},
    {"codigo": 8,"nome": "Espírito Santo","sigla": "ES"},
    {"codigo": 9,"nome": "Goiás","sigla": "GO"},
    {"codigo": 10,"nome": "Maranhão","sigla": "MA"},
    {"codigo": 13,"nome": "Minas Gerais","sigla": "MG"},
    {"codigo": 12,"nome": "Mato Grosso do Sul","sigla": "MS"},
    {"codigo": 11,"nome": "Mato Grosso","sigla": "MT"},
    {"codigo": 14,"nome": "Pará","sigla": "PA"},
    {"codigo": 15,"nome": "Paraíba","sigla": "PB"},
    {"codigo": 17,"nome": "Pernambuco","sigla": "PE"},
    {"codigo": 18,"nome": "Piauí","sigla": "PI"},
    {"codigo": 16,"nome": "Paraná","sigla": "PR"},
    {"codigo": 19,"nome": "Rio de Janeiro","sigla": "RJ"},
    {"codigo": 20,"nome": "Rio Grande do Norte","sigla": "RN"},
    {"codigo": 22,"nome": "Rondônia","sigla": "RO"},
    {"codigo": 23,"nome": "Roraima","sigla": "RR"},
    {"codigo": 21,"nome": "Rio Grande do Sul","sigla": "RS"},
    {"codigo": 24,"nome": "Santa Catarina","sigla": "SC"},
    {"codigo": 26,"nome": "Sergipe","sigla": "SE"},
    {"codigo": 25,"nome": "São Paulo","sigla": "SP"},
    {"codigo": 27,"nome": "Tocantins","sigla": "TO"}
  ];

  constructor(
    public activeModal: NgbActiveModal,
    public contadorService: ContadorService,
    public toastyService: ToastrService,
    private tokenService: TokenService
  ) { }

  ngOnInit() {
    this.tokenService.canActivate();
    this.telefone = this.contador.contato.dddTelefone1 + this.contador.contato.telefone1;

    this.seqCRCFull = this.contador.seqCrc;
    this.seqCRC = this.contador.seqCrc.substring(3, 10);
  }

  loadBodyContador(){
    
    let body = {
      cnpjSucessora: this.contador.cnpjSucessora.toUpperCase(),
      classificacaoCrc : this.contador.classificacaoCrc,
      ufCrc : this.contador.ufCrc,
      contato: {
        dddTelefone1: this.telefone.substring(0,2) ,
        telefone1 : this.telefone.substring(2,11),
        correioEletronico : this.contador.contato.correioEletronico
      },
      seqCrc : this.seqCRCFull,
      tipoCrc : this.contador.tipoCrc,
      porteEmpresa : this.contador.porteEmpresa,
      nomeContabilista : this.contador.nomeContabilista,
      cpfCnpj : this.contador.cpfCnpj.toUpperCase()
      //origemReceita : false
    }
    this.salvarEdicao(body);
  }

  salvarEdicao(body){
    this.isLoading = true;
    this.contadorService.putContador(this.contador.idContador ,body)
    .then( data => {
      this.toastyService.success('Contador editado!');
      this.activeModal.dismiss();
      this.isLoading = false;
      this.reload.emit();
    })
    .catch( err => {
      this.toastyService.error(err);
      this.activeModal.dismiss();
      this.isLoading = false;
    })
  }

}
